import { watch } from "vue";
import usePaginator from "vue-use-paginator";

const state = reactive({
  isRefreshing: false,
  transactionsLoadFailed: false,
});
const paginator = usePaginator({
  pageSize: 10,
  numItems: 0,
  numButtons: 6,
});
let accountAddressWatcherInitialized = false;

export const useBalanceRefresh = () => {
  const userStore = useUserStore();
  const { isRefreshing, transactionsLoadFailed } = toRefs(state);
  const { getUserBalance, getTransactions } = useUserController();

  const {
    page,
    pageSize,
    numItems,
    numPages,
    buttons,
    hasPrev,
    hasNext,
    goPrev,
    goNext,
    goStart,
  } = paginator;

  const refreshTransactions = async () => {
    goStart();
    await getUserBalance();
    const { transactions, statusCode } = await getTransactions(
      page.value,
      pageSize.value
    );
    transactionsLoadFailed.value = statusCode !== 200;
    numItems.value = transactions.total;
  };

  const refreshUserFinancials = async () => {
    if (isRefreshing.value) return;
    if (!userStore.accountAddress) return false;
    isRefreshing.value = true;
    try {
      await refreshTransactions();
    } finally {
      isRefreshing.value = false;
    }

    return true;
  };

  const getNextTransactions = async () => {
    if (!userStore.accountAddress) return;
    isRefreshing.value = true;
    try {
      const { transactions, statusCode } = await getTransactions(
        page.value,
        pageSize.value
      );
      transactionsLoadFailed.value = statusCode !== 200;
      numItems.value = transactions.total;
    } finally {
      isRefreshing.value = false;
    }
  };

  if (import.meta.client && !accountAddressWatcherInitialized) {
    accountAddressWatcherInitialized = true;
    watch(
      () => [userStore.accountAddress, userStore.authToken],
      ([accountAddress, authToken]) => {
        if (!accountAddress || !authToken) return;
        if (userStore.transactions.records.length > 0) return;
        void refreshUserFinancials();
      },
      { immediate: true }
    );
  }

  return {
    isRefreshing,
    transactionsLoadFailed,
    page,
    pageSize,
    numItems,
    numPages,
    buttons,
    hasPrev,
    hasNext,
    goPrev,
    goNext,
    refreshUserFinancials,
    getNextTransactions,
  };
};
